const theme = {
  units: {
    baseUnit: 1, // 1 rem,
  },
  colors: {
    light: '#FFFFFF',
    dark: '#101010',
    // lightCream: '#E6DFD6',
    // darkCream: '#C5AB97',
  },
  breakPoints: {
    // (lower limit)
    med: 360,
    lrg: 760,
  },
  fonts: {
    heading: 'Yeseva One',
    main: 'PT Sans',
  },
  transition: {
    standard: 450,
    short: 300,
  },
};

export const injectGlobalStyles = injectGlobal => {
  injectGlobal`
  body, body * {
    font-family: '${theme.fonts.main}';
  }
  html {
    font-size: 18px;
  }
`;
};

export default theme;



// WEBPACK FOOTER //
// ./src/layouts/theme.js